export const TYPE_TEXT = "text";
export const TYPE_NOTE = "note";
export const TYPE_FILE = "file";
export const TYPE_CONTACT = "contact";
export const TYPE_LOCATION = "location";
export const TYPE_STICKER = "sticker";
export const TYPE_FORM = "form";
